import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

export type VDataTablePagenation = {
    descending: boolean,
    page: number,
    rowsPerPage: number // -1 for All
    sortBy: string,
    totalItems: number
}

export type DataOptions = {
  page: number
  itemsPerPage: number
  sortBy: string[]
  sortDesc: boolean[]
};

let states = ['companyTableState', 'promoNewsTableState', 'catalogOrderTableState', 'payableCompanyTableState', 'companyInvoiceTableState', 'rentalConsoleTableState']

@Module({ name: 'preference', namespaced: true, dynamic: true, store: store })
class PreferenceStore extends VuexModule {
    companyTableState: DataOptions = {
        sortDesc: [true],
        page: 1,
        itemsPerPage: -1,
        sortBy: ["startDate"],
    };

    promoNewsTableState: DataOptions = {
        sortDesc: [true],
        page: 1,
        itemsPerPage: 25,
        sortBy: ["date"],
    }

    catalogOrderTableState: DataOptions = {
        sortDesc: [true],
        page: 1,
        itemsPerPage: 25,
        sortBy: ["date"],
    }

    payableCompanyTableState: DataOptions = {
        sortDesc: [true],
        page: 1,
        itemsPerPage: 25,
        sortBy: ["date"],
    }

    companyInvoiceTableState: DataOptions = {
        sortDesc: [true],
        page: 1,
        itemsPerPage: -1,
        sortBy: ["date"],
    }

    rentalConsoleTableState: DataOptions = {
        sortDesc: [true],
        page: 1,
        itemsPerPage: -1,
        sortBy: ["date"],
    }

    @Mutation
    LOAD_PREFERENCES() {
        const version = localStorage['pref_version'];
        if(version !== "1") {
            localStorage['pref_version'] = "1";
            for(const s of states) {
                delete localStorage[s];
            }
        }
        else {
            const self: any = this;
            for(const s of states) {
                if(localStorage[s])
                    self[s] = JSON.parse(localStorage[s]);
            }
        }
    }

    @Mutation
    UPDATE_COMPANY_TABLE_STATE(val: DataOptions) {
        this.companyTableState = val;
        localStorage.setItem("companyTableState", JSON.stringify(val));
    }

    @Mutation
    UPDATE_PROMO_NEWS_TABLE_STATE(val: DataOptions) {
        this.promoNewsTableState = val;
        localStorage.setItem("promoNewsTableState", JSON.stringify(val));
    }

    @Mutation
    UPDATE_CATALOG_ORDER_TABLE_STATE(val: DataOptions) {
        this.catalogOrderTableState = val;
        localStorage.setItem("catalogOrderTableState", JSON.stringify(val));
    }

    @Mutation
    UPDATE_PAYABLE_COMPANY_TABLE_STATE(val: DataOptions) {
        this.payableCompanyTableState = val;
        localStorage.setItem("payableComapnyTableState", JSON.stringify(val));
    }

    @Mutation
    UPDATE_COMPANY_INVOICE_TABLE_STATE(val: DataOptions) {
        this.companyInvoiceTableState = val;
        localStorage.setItem("companyInvoiceTableState", JSON.stringify(val));
    }

    @Mutation
    UPDATE_RENTAL_CONSOLE_TABLE_STATE(val: DataOptions) {
        this.rentalConsoleTableState = val;
        localStorage.setItem("rentalConsoleTableState", JSON.stringify(val));
    }
}

export default getModule(PreferenceStore);
